import xss from "xss";

export const getSecureText = text => {
    return xss(text);
};